import api from '../../api';
import router from '../../router'
import { random } from '../../utils/strings';
import { attachmentStructure } from '../../components/form/structure';
const cloneDeep = require('lodash/cloneDeep');

export default {
    namespaced: true,
    state: {
        initial: { title: '', sendingTo: '', assignedToUserId: '', assignedToBoxId: '' },
        initialized: false,
        sendingTo: '',
        sendingToContactId: null,
        sendingToUserId: null,
        sendingToBoxId: null,
        assignedToUserId: '',
        assignedToBoxId: '',
        title: '',
        sendEmail: false,
        email: {
            address: '',
            body: '',
        }
    },
    getters: {
        sendingTo(state) {
            return state.sendingTo;
        },
        sendingToContactId(state) {
            return state.sendingToContactId;
        },
        sendingToBoxId(state) {
            return state.sendingToBoxId;
        },
        sendingToUserId(state) {
            return state.sendingToUserId;
        },
        assignedToBoxId(state) {
            return state.assignedToBoxId;
        },
        assignedToUserId(state) {
            return state.assignedToUserId;
        },
        title(state) {
            return state.title;
        },
        sendEmail(state) {
            return state.sendEmail;
        },
        email(state) {
            return state.email;
        },
        hasUnsavedChanges(state) {
            return state.initialized && ['title', 'sendingTo', 'assignedToUserId', 'assignedToBoxId'].some(key => state[key] !== state.initial[key]);
        },
        initial(state) {
            return state.initial;
        }
    },
    mutations: {
        sendingTo(state, sendingto) {
            state.sendingTo = sendingto.trim();
        },
        sendingToContactId(state, sendingToContactId) {
            if (sendingToContactId) state.sendingtoUserId = state.sendingToBoxId = state.sendingTo = '';
            state.sendingToContactId = sendingToContactId;
        },
        sendingToUserId(state, sendingToUserId) {
            if (sendingToUserId) state.sendingToContactId = state.sendingToBoxId = state.sendingTo = '';
            state.sendingToUserId = sendingToUserId;
        },
        sendingToBoxId(state, sendingToBoxId) {
            if (sendingToBoxId) state.sendingToContactId = state.sendingToUserId = state.sendingTo = '';
            state.sendingToBoxId = sendingToBoxId;
        },
        assignedToBoxId(state, assignee) {
            if (assignee) state.assignedToUserId = '';
            state.assignedToBoxId = assignee;
        },
        assignedToUserId(state, assignee) {
            if (assignee) state.assignedToBoxId = '';
            state.assignedToUserId = assignee;
        },
        title(state, title) {
            state.title = title;
        },
        sendEmail(state, sendEmail) {
            state.sendEmail = sendEmail;
        },
        email(state, email) {
            state.email = email;
        },
        init(state, props) {
            // set initial state, for evaluating changes later
            if (!props) {
                props = { title: state.title, sendingTo: state.sendingTo, assignedToUserId: state.assignedToUserId, assignedToBoxId: state.assignedToBoxId };
            }
            for (let key in props) {
                state[key] = props[key];
                state.initial[key] = props[key];
            }
            state.sendEmail = false;
            state.initialized = true;
        }
    },
    actions: {
        async addForms({ state, commit, rootGetters }, formIds) {
            let scrollToIndex = rootGetters['package/pkg'].sequence.length;
            let promises = formIds.map(id => api.get(`forms/${id}`, { drafts: 0 }));
            let forms = await Promise.all(promises);
            let newSeq = [], newFormIds = [];
            for (let form of forms) {
                form.id = `new${form.id}`;
                newSeq.push({ type: 'form', id: form.id });
                newFormIds.push(form.id);
            }
            forms = rootGetters['form/forms'].concat(forms);
            commit('filler/forms', forms, { root: true });
            commit('form/setForms', forms, { root: true });
            commit('filler/scrolledToItem', scrollToIndex, { root: true });
            commit('package/sequence', rootGetters['package/sequence'].concat(newSeq), { root: true });
            commit('filler/hasUnsavedChanges', true, { root: true });
            setTimeout(() => {
                commit('filler/calculateAll', newFormIds, { root: true });
            });
        },
        addAttachment({ rootGetters, commit }) {
            let scrollToIndex = rootGetters['package/pkg'].sequence.length;
            let attachments = cloneDeep(rootGetters['package/pkg'].attachments);
            let id = 'new' + random(8);
            attachments[id] = attachmentStructure();
            commit('package/attachments', attachments, { root: true });
            commit('filler/scrolledToItem', scrollToIndex, { root: true });
            commit('package/sequence', rootGetters['package/pkg'].sequence.concat([{ type: 'attachment', id }]), { root: true });
            commit('filler/hasUnsavedChanges', true, { root: true });
        },
        removeItem({ rootGetters, commit }, index) {
            let seq = rootGetters['package/pkg'].sequence[index];
            if (seq.type === 'form') {
                let forms = rootGetters['form/forms'].filter(f => f.id !== seq.id);
                commit('filler/forms', forms, { root: true });
                commit('form/setForms', forms, { root: true });
            } else {
                let attachments = cloneDeep(rootGetters['package/pkg'].attachments);
                delete attachments[seq.id];
                commit('package/attachments', attachments, { root: true });
            }
            commit('filler/scrolledToItem', -1, { root: true });
            let sequence = rootGetters['package/pkg'].sequence.slice();
            sequence.splice(index, 1);
            commit('package/sequence', sequence, { root: true });
            commit('filler/hasUnsavedChanges', true, { root: true });
        },
        changeMode({ }, mode) {
            router.replace({
                params: { ...router.currentRoute.params, mode }
            });
        }
    }
}